import React from "react";
import "./Learning.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import learningLink from "../../../assets/images/learningLink.png";

const Learning = () => {
  const data = useSelector((state) => state?.agentHome?.performanceData);
  
  // Safely accessing and parsing the learning resource data
  let learningResourceData = [];
  
  try {
    const detailedLearning = data?.strengthMessage?.detailedLearning;
    
    // Check if detailedLearning exists and is a string
    if (detailedLearning && typeof detailedLearning === 'string') {
      // Parse the JSON string
      const parsedLearning = JSON.parse(detailedLearning);
      learningResourceData = parsedLearning?.learningResources || [];
      
      // IMPORTANT: Merge the affectedCallIds from learningResource (top level)
      // with the detailed learning resources
      const topLevelResources = data?.strengthMessage?.learningResource || [];
      
      // Create a map of title to affectedCallIds from top level
      const affectedCallIdsMap = {};
      topLevelResources.forEach(res => {
        if (res.title && res.affectedCallIds) {
          affectedCallIdsMap[res.title] = res.affectedCallIds;
        }
      });
      
      // Also map CallEscallation if available
      const callEscallationMap = {};
      topLevelResources.forEach(res => {
        if (res.title && res.CallEscallation) {
          callEscallationMap[res.title] = res.CallEscallation;
        }
      });
      
      // Also map affectedCallsLast25Hours if available
      const affectedCallsLast25HoursMap = {};
      topLevelResources.forEach(res => {
        if (res.title && res.affectedCallsLast25Hours) {
          affectedCallsLast25HoursMap[res.title] = res.affectedCallsLast25Hours;
        }
      });
      
      // Merge the data into the detailed learning resources
      learningResourceData = learningResourceData.map(resource => {
        const enhancedResource = { ...resource };
        
        // Add affectedCallIds from top level if available
        if (affectedCallIdsMap[resource.title]) {
          enhancedResource.affectedCallIds = affectedCallIdsMap[resource.title];
          enhancedResource.affectedCallIdsCount = affectedCallIdsMap[resource.title].length;
        }
        
        // Add CallEscallation if available
        if (callEscallationMap[resource.title]) {
          enhancedResource.CallEscallation = callEscallationMap[resource.title];
        }
        
        // Add affectedCallsLast25Hours if available
        if (affectedCallsLast25HoursMap[resource.title]) {
          enhancedResource.affectedCallsLast25Hours = affectedCallsLast25HoursMap[resource.title];
        }
        
        return enhancedResource;
      });
      
    } else if (detailedLearning && typeof detailedLearning === 'object') {
      // If it's already an object, use it directly
      learningResourceData = detailedLearning?.learningResources || [];
    }
  } catch (error) {
    console.error("Error parsing learning resources:", error);
    learningResourceData = [];
  }

  const navigate = useNavigate();

  const handleResourceClick = (resource) => {
    console.log("Navigating with resource:", resource); // Debug log
    navigate("/learninglink", { 
      state: { 
        resource: {
          ...resource,
          // Ensure these arrays are included
          affectedCallIds: resource.affectedCallIds || [],
          CallEscallation: resource.CallEscallation || [],
          affectedCallsLast25Hours: resource.affectedCallsLast25Hours || []
        }
      } 
    });
  };

  return (
    <div className="learning-container">
      <div className="learning-content">
        {learningResourceData?.length > 0 ? (
          <table className="learning-table">
            <thead>
              <tr>
                <th className="header-number">#</th>
                <th className="header-lesson">Lessons</th>
                <th className="header-links">Links</th>
              </tr>
            </thead>
            <tbody>
              {learningResourceData.map((resource, index) => (
                <tr key={resource?.id || index} className="learning-item">
                  <td className="resource-id">
                    {String(index + 1).padStart(2, "0")}
                  </td>
                  <td className="resource-title">
                    {resource?.title}
                  </td>
                  <td className="resource-link-cell">
                    <button
                      className="link-icon-btn"
                      onClick={() => handleResourceClick(resource)}
                      title="View Lesson"
                    >
                      <img 
                        src={learningLink} 
                        alt="link icon" 
                        className="learning-link-img"
                      />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="no-resources">
            <p>No learning resources available.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Learning;